<template>
    <div class="f-info">
        <div class="title">
            <div class="title__folder-name">
                <p class="text">
                    {{ selectedItem.title ? selectedItem.title : selectedItem.name }}
                </p>

                <svg @click="closeInfo" class="close-btn"
                    width="18"
                    height="19"
                    viewBox="0 0 18 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M14 4.66673L4 14.6667M3.99996 4.66669L13.9999 14.6666"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                    />
                </svg>
            </div>

            <p class="title__files-quantity">
                Файлов: {{ allFiles.length }}
            </p>
        </div>

        <div class="body">
            <div v-for="item in allFiles"
                :key="item.id || item.path"
                class="body__item"
                @click="openPreview(item)"
            >
                <img v-if="item.type_id === 1"
                    :src="`${domain}${item.path}`"
                    alt=""
                />

                <video v-else-if="item.type_id === 2"
                    controls
                    loop
                >
                    <source :src="`${domain}${item.path}`" />
                </video>
            </div>
        </div>
    </div>

    <Transition name="fade">
        <div v-if="previewItem"
            class="content-preview-overlay"
            @click.self="closePreview"
        >
            <button type="button"
                class="content-preview-overlay__close"
                @click="closePreview"
            >
                <svg width="18"
                    height="19"
                    viewBox="0 0 18 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M14 4.66673L4 14.6667M3.99996 4.66669L13.9999 14.6666"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                    />
                </svg>
            </button>

            <img v-if="previewItem.type_id === 1"
                :src="`${domain}${previewItem.path}`"
                alt=""
                @click.stop
            />

            <video v-else-if="previewItem.type_id === 2"
                controls
                @click.stop
            >
                <source :src="`${domain}${previewItem.path}`" />
            </video>
        </div>
    </Transition>
</template>

<script>
import { mapState } from 'vuex/dist/vuex.cjs.js';

export default {
    name: 'ContentInfoComponent',

    props: {
        domain: {
            type: String,
            required: true,
        },
    },

    emits: ['closeInfo'],

    data() {
        return {
            previewItem: null,
        };
    },

    computed: {
        ...mapState('content', ['selectedItem', 'selectedRows']),

        allFiles() {
            const result = [];

            const collectFiles = (item) => {
                if (!item) return [];

                // папка
                if (Array.isArray(item.content)) {
                    return item.content;
                }

                // одиночный файл
                return [item];
            };

            // selectedItem
            result.push(...collectFiles(this.selectedItem));

            // selectedRows
            this.selectedRows.forEach(row => {
                result.push(...collectFiles(row));
            });

            // удаляем дубликаты
            const uniqueMap = new Map();

            result.forEach(file => {
                const key = file.id ?? file.path;
                uniqueMap.set(key, file);
            });

            return Array.from(uniqueMap.values());
        },

        images() {
            return this.allFiles.filter(file => file.type_id === 1);
        },

        videos() {
            return this.allFiles.filter(file => file.type_id === 2);
        },
    },

    methods: {
        closeInfo() {
            this.$emit('closeInfo');
        },

        openPreview(item) {
            this.previewItem = item;
            document.addEventListener('keydown', this.onPreviewKeydown);
        },

        closePreview() {
            this.previewItem = null;
            document.removeEventListener('keydown', this.onPreviewKeydown);
        },

        onPreviewKeydown(event) {
            if (event.key === 'Escape') {
                this.closePreview();
            }
        },
    },

    beforeUnmount() {
        document.removeEventListener('keydown', this.onPreviewKeydown);
    },
};
</script>

<style scoped lang="scss">
.body__item {
    cursor: pointer;
}

.content-preview-overlay {
    position: fixed;
    inset: 0;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.85);

    img,
    video {
        max-width: 90vw;
        max-height: 90vh;
        object-fit: contain;
    }

    &__close {
        position: absolute;
        top: 16px;
        right: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        border: none;
        background: none;
        color: #fff;
        cursor: pointer;
    }
}
</style>
